import React, { useState,useContext, useEffect } from 'react'
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

import Input from '../Input'
import styled from 'styled-components'
import api from '../../services/api';

import {toast } from 'react-toastify';
import app from '../../firebase/config';
import { PagesContext } from '../../context/pages'



const CardInput = styled.section`

    display: flex;
    width: 100%;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.2rem;
    }

    div{
        margin-right:1.5rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;
        div{
            margin-left: 0rem;
        }

    }


`
const ModalEditButton = (props) => {
    const {buttonId,buttonName,buttonImage} = useContext(PagesContext)

    const [nameButton,setNameButton] = useState()
    const [image,setImage] = useState()
    
    const handleEdit = async () => {

        if(image){
            await storageImages()
            window.location.href="/dashboard/button"
        }

        const response = await api.put("/pages/update/button", {
            name: nameButton,
            id:buttonId
        })
        
    }

    const storageImages = async (id, images) => {

        const loadingToastId = toast.loading("Processando Botão...");

        return app.storage().ref(`/pages/buttons/${image.name}`).put(image)
            .then(() => {
                console.log(`Imagem ${image.name} carregada com sucesso`);
                return app.storage().ref(`/pages/buttons/${image.name}`).getDownloadURL();
            })
            .then(image => {
                toast.update(loadingToastId, {
                    render: "Botão inserido com sucesso!",
                    type: "success",
                    isLoading: false,
                    autoClose: 1000
                });
                return api.put("/pages/update/button", {
                    name: nameButton,
                    image: image,
                    id:buttonId
                })


            })
            .catch(error => {
                console.error(`Erro ao carregar a imagem ${image.name}:`, error);
            });


    }

    useEffect(() => {

        setNameButton(buttonName)

    },[buttonName])
    
    return(

        <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
    >
        <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                Informações do botão
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <CardInput>
                <Input name={"Nome do botão *"} maxLength={16} value={nameButton} onChange={(e) => setNameButton(e.target.value)} />
                <Input name={"Icone do botão *"} accept={".png, .jpg, .jpeg"} type={"file"} onChange={(e) => setImage(e.target.files[0])} />
 


            </CardInput>

        </Modal.Body>
        <Modal.Footer>
            <Button onClick={() => {handleEdit();props.onHide()}}>Salvar</Button>
        </Modal.Footer>
    </Modal>

    )
}

export default ModalEditButton